<template>
  <section>
    <HeaderBar :my-title="myHeader" :is-prev="true"></HeaderBar>
    <div class="form-box">
      <div class="part1">
        <h6>现场接待网上预约</h6>
        <div>接待地址：上海市浦东新区环科路515号1幢211室</div>
        <div>（9:15-17:15）</div>
      </div>

      <div class="part2">
        <h6>选择服务类型（必选）</h6>
        <div   v-for="(item,index) in formData">
          <span>{{item.bussgroup}}</span>
          <ul>
            <li v-for="(item2,index2) in item.bussarray" :class="{active:index==actNum2&&index2==actNum1}" @click="toggleAct(index2,index,item2.busscode)" myType="item2.busscode">{{item2.bussname}}</li>
          </ul>
       
        </div>
       
      </div>

      <div class="part3">
        <h6>选择服务类型</h6>
        <dl>
          <dt><b>*</b>姓名：</dt>
          <dd>
            <input type="text" v-model="subData.name">
            <span>（2-5个中文字符）</span>
          </dd>
          <dt>
            <b>*</b>性别：
          </dt>
          <dd class="sex">
            <span @click="tabFun('sex','male')" :class="{active:subData.sex=='male'}">男</span>
            <span @click="tabFun('sex','female')" :class="{active:subData.sex=='female'}">女</span>
          </dd>
          <dt><b>*</b>证件类型：</dt>
          <dd>
            <select class="my-id" @change="tabId" v-model="selected">
              <option value="身份证"  @change="tabFun('idType',1)" _val="1">身份证</option>
              <option value="军官证"  @change="tabFun('idType',3)" _val="3">军官证</option>
            </select>

          </dd>

          <dt><b>*</b>证件号码：</dt>
          <dd>
            <input type="text"  v-model="subData.idNum">
            <span v-if="idTypeOff">（15-18位身份证）</span>
          </dd>
          <dt><b>*</b>固定电话/手机：</dt>
          <dd>
             <input type="text" v-model="subData.contact">
          </dd>
          <dt><b>*</b>游戏通行证：</dt>
          <dd>
             <input type="text" v-model="subData.sndaAccount">
          </dd>
          <dt><b>*</b>是否之前有事件反馈：</dt>
          <dd class="shifou">
            <span @click="tabFun('feedback','0')"  :class="{active:subData.feedback=='0'}">是</span>
            <span @click="tabFun('feedback','1')" :class="{active:subData.feedback=='1'}">否</span>
          </dd>
        </dl>

      </div>
      <div class="part4">
        <h6>预约来访时间（必选）</h6>
        <div class="arrive-data"><b>*</b>来访日期</div>
        <div>
            
          <datepicker @on-change="getDate"></datepicker>
         <select name="" id="hour" v-model="myHour" @change="getHour" ref="hourRef">
            <option value="9" >9</option>
            <option value="10">10</option>
            <option value="11">11</option>
            <option value="12">12</option>
            <option value="13">13</option>
            <option value="14">14</option>
            <option value="15">15</option>
            <option value="16">16</option>
             <option value="17">17</option>
          </select>时
          <select name="" id="sec" v-model="mySec" ref="secRef">
            <option value="00">00</option>
            <option value="15">15</option>
            <option value="30">30</option>
            <option value="45">45</option>
          </select>分
        </div>
        <div class="shuom">(预约日期需至少提前一天，时间范围9:30-17:15)</div>
        <div class="yzcode"><b>*</b><input type="text" v-model="subData.captchaCode"><img :src="codeUrl" @click="checkCode"></div>
        
      </div>
      <div class="tijiao"><button  @click="sendMsg">确认提交</button></div>
    </div>
  
    
   <MyDialog :isShow="myShow" :myTitle="diaTitle" :myContent="diaCon" @on-close="closeDia" ></MyDialog>
  </section>
  
  

</template>

<script>

import HeaderBar from './base/header'

import datepicker from './base/datepicker';
import MyDialog from './base/dialog';

// Use v-calendar, v-date-picker & v-popover components


export default {
  components: {
    HeaderBar,
   datepicker,
   MyDialog
   
  },
  name: 'orderForm',
  created: function () {
   this.getMeg()
  },
  data () {
    return {
       myHeader:"现场接待预约单",
       myShow:false,
       diaTitle:'',
       diaCon:'',
       idTypeOff:true,
       selected:'',
       formData:[],
       actNum1:0,
       actNum2:0,
       selectedValue: new Date(),
       codeUrl:"",
       subData:{
          "serviceType": "",
          "name": "",
          "sex": "male",
          "idType": 1,
          "idNum": "",
          "contact": "",
          "sndaAccount": "",
          "feedback": "1",
          "accessTime": "",
          "captchaKey": "",
          "captchaCode": ""
        },
        endDate:'',
        myHour:"",
        mySec:""
     
       
           
    }
        
  },
  methods:{
     getMeg(){
       this.$http.get('/api/service/counter')
        .then((response)=> {
         console.log(response.data.data)
         this.formData=response.data.data.bussGroupList
         this.subData.captchaKey = response.data.data.captcha.key
       
         this.codeUrl = response.data.data.captcha.url

         this.subData.serviceType = this.formData[0].bussarray[0].busscode
          console.log(this.subData.serviceType)
           
        })
        .catch((error) =>{
          console.log(error);
        });
     },
     toggleAct(num,num2,code){
      
        
        this.actNum1 = num;
        this.actNum2 = num2; 
        this.subData.serviceType = code    
       
     },
    tabId(ele){
        var _id = ele.target.value
        if(_id=="军官证"){
          this.subData.idType = 3 
          this.idTypeOff = false
        }else{
          this.subData.idType = 1 
          this.idTypeOff = true
        }
        console.log(_id)
    },
     tabFun (attr,tar){    
     
        this.subData[attr] = tar 
         
     },
     getDate(date){
      this.endDate = date;
      console.log( this.endDate)
     },
     getHour(){
         console.log(this.myHour)
     },
      addDay(date, number) {
          date.setDate(date.getDate() + number);
          return date;
      },
      checkCode(){
        this.$http.get('/api/captchaUrl')
          .then((response)=> {
           console.log(response.data.data)
           this.codeUrl = response.data.data.url
           this.subData.captchaKey = response.data.data.key

             
          })
          .catch((error) =>{
            console.log(error);
          });
          this.$refs.hourRef.selectedIndex=-1
          this.$refs.secRef.selectedIndex=-1
         
          
      },
      autoData (){
        var data = this.subData  
        if(!data.name || data.name.length < 2 || data.name.length > 10) {
          return '姓名不能为空且长度为2-10个字符';
        }
        if(!data.idNum ||
            data.idType == '1' && (data.idNum.length < 15 || data.idNum.length > 18)) {
            return '证件号码不正确';
        }
        if(!data.contact) {
            return '请填写联系方式';
        }
        if(!data.sndaAccount) {
            return '请填写游戏通行证';
        }
        
        var now = new Date();
        var dateStart = this.addDay(new Date(now.getFullYear(), now.getMonth(), now.getDate(), 9, 30, 0), 1);
        var myData = new Date(this.endDate.replace(/-/g,"/"));

       // data.accessTime = new Date(dateStr);
        myData.setHours(this.myHour);
        myData.setMinutes(this.mySec);
       // this.endDate = new Date(this.endDate);
        var dateEnd = new Date(  myData.getFullYear(),   myData.getMonth(),  myData.getDate(), 17, 15, 0);
       if(!this.mySec||!this.myHour) {
            return '请选择来访时间';
        }
        console.log(myData+' '+dateStart+' '+dateEnd)
        if( myData < dateStart || myData > dateEnd) {
            return '预约日期最少需要提前一天，预约时间范围 9:30-17:15';
        }
         if(data.captchaCode.length == 0 || !data.captchaCode) {
          return '请填写验证码';
        }

         return null;
      },
    
     sendMsg(){
     
      // this.countNumber(4,8)
       var r =this.autoData()   
        if(r) {
             this.myShow = true
            
             this.diaCon = r 
             return false 
        }     
        this.subData.accessTime = this.endDate + " " + this.myHour + ":" + this.mySec
       

        this.$http.post('/api/service/submitCounter',this.subData)
          .then((response)=> {
            if(response.data.status==0){
              this.myShow = true
               this.diaCon = "成功递交"
             }else{
              this.myShow = true
              this.diaCon = response.data.errmsg
             }
              this.checkCode()
               console.log(response)
          })
          .catch((error) =>{
            
          });
     },
     closeDia(){
        this.myShow = false

     }


     
  },
  mounted () {
    this.checkCode()
  }
}
</script>


<style scoped>
.form-box h6{font-size: 0.32rem;padding-left: 0.48rem;background: url(../assets/yuan-ico.png) left center no-repeat;background-size:0.27rem 0.28rem;margin-top: 0.5rem}
.form-box{font-size: 0.3rem}
.form-box .part1,.form-box .part2,.form-box .part3{padding-bottom: 0.37rem;border-bottom: 1px solid #dedddd;padding-left: 0.42rem;}
.form-box .part1 div{color: #999}
.form-box .part1 div:nth-of-type(1){margin: 0.32rem 0 0.2rem 0}
.part2 span{font-size: 0.3rem;display: block;margin: 0.04rem 0 0.36rem 0}
.part2 span:nth-of-type(1){margin-top: 0.4rem}
.part2  li{float: left;width: 2.08rem;height: 0.62rem;line-height: 0.62rem;text-align: center;margin-right:0.2rem;border:1px solid #dedddd;font-size: 0.22rem;margin-bottom: 0.36rem}
.part2  li:nth-of-type(3n){margin-right: 0}
.part2  ul{overflow:hidden;}
.part2 .active{border: 1px solid #e5004f;color: #e5004f}
.part3 dt b{color: #e5004f;margin-right: 0.1rem}
.part3 dt{font-size: 0.28rem;margin: 0.34rem 0}
.part3 dd input{width:4.2rem;height: 0.68rem;border: 1px solid #dedddd;text-indent: 0.1rem}
.part3 dd span{color: #aaaaaa;font-size: 0.26rem;}
.part3 dt:nth-of-type(2),.part3 dt:nth-of-type(7){display: inline-block;margin-top: 0.5rem}
.part3 dd:nth-of-type(2),.part3 dd:nth-of-type(7){display: inline-block;}
.part3 {padding-left: 0.4rem}
.part3 .sex span,.part3 .shifou span{width: 1.60rem;height: 0.56rem;display: inline-block;line-height: 0.56rem;text-align: center;border: 1px solid #dedddd;color: #000}
.part3 .sex .active,.part3 .shifou .active{background:#e5004f;color: #fff}
.my-id{width:4.2rem;height: 0.68rem;border: 1px solid #dedddd;text-indent: 0.2rem}
.arrive-data b,.yzcode b{color: #e5004f;margin-right: 0.1rem}
.arrive-data {font-size: 0.28rem;margin: 0.34rem 0}
.rili{width: 2rem;border: 1px solid #dedddd;height: 0.68rem;margin-right: 0.18rem}
.calendar-class{width: 2rem;border: 1px solid #dedddd;height: 0.68rem;margin-right: 0.18rem}
#hour{width: 1.16rem;height: 0.68rem;text-indent: 0.1rem;font-size: 0.24rem;margin-right: 0.1rem}
#sec{width: 1.18rem;;height: 0.68rem;text-indent: 0.1rem;font-size: 0.24rem;margin-right: 0.1rem}
.shuom{color: #aaaaaa;font-size: 0.26rem;margin-top: 0.26rem}
.part4{padding-left: 0.42rem}
.yzcode input{width: 1.6rem;height: 0.58rem;vertical-align: middle;}
.yzcode img{width: 2rem;height: 0.68rem;display: inline-block;vertical-align: middle;background-size: cover}
.yzcode{padding-bottom: 0.45rem;margin-top: 0.4rem}
.tijiao button{width:6.75rem;height: 0.74rem;background: #e5004f;line-height: 0.74rem;text-align: center;margin-top: 0.36rem;border: none;color: #fff;margin-left: 0.36rem;}
.tijiao {width: 100%;height: 1.4rem;background: #e6e6e6;}
</style>



// WEBPACK FOOTER //
// src/components/orderForm.vue